/**
 * Google Analytics (GA4) and optional super-admin activity logging.
 * - Page views and events sent to GA when REACT_APP_GA_MEASUREMENT_ID is set.
 * - trackEvent() can also log to audit (user activity) for super-admin visibility.
 */

const GA_ID = (typeof process !== 'undefined' && process.env?.REACT_APP_GA_MEASUREMENT_ID) || 'G-V5JF9EYP2N';

export function getGAMeasurementId() {
  return GA_ID;
}

export function isGAEnabled() {
  return !!GA_ID;
}

/** Load gtag script and init GA4. Call only when user has tracking consent. Consent default/update are set in index.html + ConsentContext (Consent Mode v2). */
export function initGA() {
  if (!GA_ID || typeof window === 'undefined') return;
  if (window.gtag && window.__gtagLoaded) return;
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false });
  window.__gtagLoaded = true;
}

/** Send a page view to GA. No-op if no consent or gtag not loaded. */
export function pageView(path, title) {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path || window.location.pathname,
    page_title: title || document.title,
  });
}

/**
 * Send a custom event to GA (only when consent given) and optionally log to audit.
 * @param {string} name - Event name (e.g. 'button_click', 'match_start')
 * @param {object} params - { category, label, value, ... } or any gtag params
 * @param {object} options - { logToAudit: true, trackingConsent: boolean }
 */
export function trackEvent(name, params = {}, options = {}) {
  if (options.trackingConsent !== false && GA_ID && window.gtag) {
    window.gtag('event', name, params);
  }
  if (options.logToAudit && typeof options.logUserActivity === 'function') {
    options.logUserActivity(name, params);
  }
}
